import { render, staticRenderFns } from "./TheInput.vue?vue&type=template&id=023bd820&scoped=true"
import script from "./TheInput.vue?vue&type=script&lang=js"
export * from "./TheInput.vue?vue&type=script&lang=js"
import style0 from "./TheInput.vue?vue&type=style&index=0&id=023bd820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023bd820",
  null
  
)

export default component.exports